

App.OrderMapPopupV2Component = Em.Component.extend
  classNames: [ 'order-map-popup', 'v2' ]

  env:     Em.inject.service('environment')
  session: Em.inject.service('session')
  notifier: Em.inject.service('notifier')

  courierBinding: Ember.Binding.oneWay('order.courier')
  couriers: null

  localtimer: 0

  filteredCouriers: (->
    rest_id = @get('order.restaurant.id')
    @get('couriers').filter (el)->
      # у пользователя могут быть недоступны рестораны, к которых относится курьер,
      # делаем фильтрацию таким образом, чтобы не инициировать запрос недоступных ресторанов
      !el.get('disabled') && el._data.restaurants.length == 0 || el._data.restaurants.map((v) -> v.id).indexOf(rest_id) > -1
  ).property('couriers','order')

  alignPopup: ->
    return if @get('isDestroyed')

    $layout = Em.$('.orders-layout')

    MARGIN = 15

    { top }    = $layout.position()
    areaHeight = $layout.outerHeight()

    maxHeight = areaHeight - 2 * MARGIN
    @$().css
      top: top + MARGIN
      'max-height': maxHeight

    @$('.popup-body').css('max-height': maxHeight - @$('.popup-header').outerHeight() )

  bindedAlignPopup: (->
    => Em.run.debounce @, @alignPopup, 150
  ).property()

  registerAlignHandler: (->
    @alignPopup()

    Em.$(window).on 'resize', @get('bindedAlignPopup')
  ).on('didInsertElement')

  removeAlignHandler: (->
    Em.$(window).off 'resize', @get('bindedAlignPopup')
  ).on('didInsertElement')

  disposing:         false

  orderConfirm:      Em.computed.bool('order.confirmed_at')
  courierConfirm:    Em.computed.bool('order.courier_confirmed_at')
  restaurantConfirm: Em.computed.bool('order.restaurant_confirmed_at')

  courierConfirmHint: (->
    if @get('order.courier_confirmed_at')
      # todo i18n
      "Курьер принял заказ #{ moment(@get('order.courier_confirmed_at')).format('DD.MM.YYYY в HH:mm') }"
    else
      # todo i18n
      "Заказ еще не был принят курьером"
  ).property('order.courier_confirmed_at')

  orderConfirmHint: (->
    if @get('order.confirmed_at')
      # todo i18n
      "Заказ был подтвержден #{ moment(@get('order.confirmed_at')).format('DD.MM.YYYY в HH:mm') }"
    else
      # todo i18n
      "Заказ еще не был подтвержден"
  ).property('order.confirmed_at')

  restaurantConfirmTimeout: (->
    return false if @get('order.restaurant_confirmed_at')
    @get('order.restaurantConfirmDeadlineAt') < new Date
  ).property('order.restaurant_confirmed_at')

  restaurantConfirmHint: (->
    if @get('order.restaurant_confirmed_at')
      # todo i18n
      "Заказ был принят рестораном #{ moment(@get('order.restaurant_confirmed_at')).format('DD.MM.YYYY в HH:mm') }"
    else if @get('order.restaurantConfirmDeadlineAt') < new Date
      # todo i18n
      "Заказ не принят рестораном, проверьте журнал интеграции"
    else
      # todo i18n
      "Заказ еще не был подтвержден рестораном"
  ).property('order.restaurant_confirmed_at')

  paymentHint: (->
    return null unless @get('order.isPaymentCard')
    # todo i18n
    return "Заказ оплачен" if @get('order.payment_success')

    # todo i18n
    hints = [ 'Заказ не был оплачен' ]

    if @get('order.status') is 'pending'
      # todo i18n
      hints.push 'Подтвердите заказ, чтобы клиент смог его оплатить.'
    # else if payment and payment.get('payment_submitted')
    #   hints.push 'Процедура оплаты была инициирована, но не завершена.'

    return hints.join('. ')

     #" #{ moment(payment.get('received_date')).format('DD.MM.YYYY в HH:mm') }"

  ).property(
   'order.isPaymentCard',
   'order.payment_success',
   'order.status'
  )

  paymentStatus: (->
    return '' unless @get('order.isPaymentCard')

    if @get('order.payment_success') or @get('order.final_sum') == 0
      'payment-success'
    else
      'payment-error'
  ).property(
    'order.isPaymentCard',
    'order.payment_success',
    'order.final_sum')

  timer: (->
    Em.run.later =>
      return if !@ or @isDestroyed
      @set('localtimer', @get('localtimer')+1)
    , 20000
    @get('localtimer')
  ).property(
    'localtimer')

  shoudBeDisposed: (->
    moment(@get('order.shelf_life_till')).isBefore(new Date)
  ).property(
    'order.shelf_life_till','timer')

  statusName : (->
    @get('env').translate( "order.status.#{ @get('order.status') }" )
  ).property('order.status')

  humanPaymentSource: (->
    payment_source = "order.payment_method.#{@get('order.payment_source')}"
    payment_source_text = @get('env').translate(payment_source)
    if @get('order.used_bonuses') > 0
      payment_source_text += @get('env').translate('order.payment_method.extra_bonuses')
    payment_source_text
  ).property('order.payment_source', 'env')

  courierPickupTime: (->
    return '—' unless @get('order.pick_up_at')
    date = moment(new Date(@get('order.pick_up_at'))).tz(@get('order.timezone'))
    if date.isSame(moment(), 'day')
      date.format('H:mm')
    else
      date.format('DD MMMM в H:mm')
  ).property('order.pick_up_at')

  startCookingTime: (->
    date = moment(new Date(@get('order.cooking_start_at'))).tz(@get('order.timezone'))
    if date.isSame(moment(), 'day')
      date.format('H:mm')
    else
      date.format('DD MMMM в H:mm')
  ).property('order.cooking_start_at')

  deliveryAtTime: (->
    date = moment(new Date(@get('order.delivery_at'))).tz(@get('order.timezone'))
    if date.isSame(moment(), 'day')
      date.format('H:mm')
    else
      date.format('DD MMMM в H:mm')
  ).property('order.delivery_at')

  isDeliveryFree: (->
    not @get('order.delivery_price') or @get('order.delivery_price') == 0
  ).property('order.delivery_price')


  ###
  # Флаги для отображения
  ###
  isInTerminalState: (->
    @get('order.status') in ['complete', 'undo']
  ).property('order.status')

  isOrderCanceled: Em.computed.equal('order.status', 'undo')
  isOrderComlete:  Em.computed.equal('order.status', 'complete')
  isOrderPending:  Em.computed.equal('order.status', 'pending')


  hintMessage: (->
    message = ''

    # todo i18n
    if @get('order.isPaymentCard')
      message += "Подтвердите заказ, чтобы клиент смог его оплатить "

    # todo i18n
    message += {
      pending: """
        После подтверждения клиенту будет отправленно
        SMS-сообщение, а менеджеры ресторана получат уведомление о новом заказе
        """
      confirm:   'Заказ подтвержден'
      preparing: 'Заказ собирается'
      prepared:  'Заказ собран'
      delivery:  'Заказ доставляется курьером'
      complete:  'Заказ был успешно доставлен'
      undo:      'Заказ был отменен'
    }[@get('order.status')]

    # todo i18n
    if @get('shouldAssignCourier')
      message += ' Назначьте курьера, чтобы перевести заказ в следующий статус.'

    message
  ).property(
    'order.isPaymentCard',
    'order.status',
    'shouldAssignCourier')

  # Очень странно
  hasCourier: Em.computed.bool('order.courier.id')

  needCallText: (->
    allowedCall = @get('order.contact_call_allowed')
    return Em.I18n.t('order.contact_call_allowed') if allowedCall
    Em.I18n.t('order.contact_call_not_allowed')
  ).property('order.contact_call_allowed')

  showNeedCallText: (->
    orgFeatures = @get('session.currentOrganization.features')
    return orgFeatures.client_can_prohibit_calls
  ).property('session.availableOrganizations.features')

  showCourierAssign: (->
    @get('order.delivery') or (@get('order.dine_in') and @get('env.features.assignCourierToOrderAtTable'))
  ).property('order.delivery', 'order.dine_in', 'env.features.assignCourierToOrderAtTable')

  actions:
    # Открыть мини-попап со статусом и выставить подтвержденный
    confirmOrder: ->
      @get('statusPopup')?.send('pickStatus', 'confirm')
      @get('miniPopups').send('openPopup', 'status-popup')
      false

    disposeOrder: ->
      @set('disposing', true)
      @get('order')?.dispose()
      .then =>
        @set('disposing', false)
        @get('notifier').pushNotification
            type: 'success'
            # todo i18n
            title: 'Продукт списан'
            message: 'После списания заказ вернулся в статус "подтвержден"'
            duration: 3000


    openPopup: (type) ->
      @get('miniPopups').send('openPopup', type)
      false

    closePopup: ->
      @set('currentPopupOpened', '')
      false
